import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const getConfig = async () => {
  const { data } = await axios.get(`${API}/config`);
  return data;
};

export const createOrder = async (payload) => {
  const { data } = await axios.post(`${API}/orders`, payload);
  return data;
};

export const cancelOrder = async (orderId) => {
  const { data } = await axios.delete(`${API}/orders/${orderId}/cancel`);
  return data;
};

export const adminLogin = async (password) => {
  const { data } = await axios.post(`${API}/admin/login`, { password });
  return data.token;
};

export const fetchOrders = async (token) => {
  const { data } = await axios.get(`${API}/admin/orders`, {
    headers: { "X-Admin-Token": token },
  });
  return data;
};

export const updateOrderStatus = async (token, orderId, status) => {
  const { data } = await axios.patch(
    `${API}/admin/orders/${orderId}`,
    { status },
    { headers: { "X-Admin-Token": token } }
  );
  return data;
};

export const updateOrderPacked = async (token, orderId, packed) => {
  const { data } = await axios.patch(
    `${API}/admin/orders/${orderId}/packed`,
    { packed },
    { headers: { "X-Admin-Token": token } }
  );
  return data;
};

export const deleteOrder = async (token, orderId) => {
  const { data } = await axios.delete(`${API}/admin/orders/${orderId}`, {
    headers: { "X-Admin-Token": token },
  });
  return data;
};

export const resetOrderNumbers = async (token) => {
  const { data } = await axios.post(
    `${API}/admin/reset-order-numbers`,
    {},
    { headers: { "X-Admin-Token": token } }
  );
  return data;
};

export const clearArchive = async (token) => {
  const { data } = await axios.post(
    `${API}/admin/clear-archive`,
    {},
    { headers: { "X-Admin-Token": token } }
  );
  return data;
};

export const fetchArchive = async (token) => {
  const { data } = await axios.get(`${API}/admin/archive`, {
    headers: { "X-Admin-Token": token },
  });
  return data;
};

export const restoreOrder = async (token, orderId) => {
  const { data } = await axios.post(
    `${API}/admin/archive/${orderId}/restore`,
    {},
    { headers: { "X-Admin-Token": token } }
  );
  return data;
};
